/**
 * Regra ÚNICA de "este item do carrinho pode ser agrupado com outro igual?".
 *
 * Existia uma cópia dessa condição em cada canal (cardápio, totem/balcão,
 * mesas, PDV) e elas DIVERGIRAM: só o PDV olhava `subitems`. O resultado foi o
 * bug da pizza — uma Grande e uma Pequena do mesmo sabor viravam a mesma linha
 * do carrinho, a segunda sumia com preço/tamanho/borda, e a cozinha recebia
 * duas do primeiro tamanho.
 *
 * Por que `subitems` e `etapas` importam: o PizzaPopup grava tamanho, sabores e
 * borda em `subitems` — e NÃO seta `observation`, `combo_type` nem
 * `step_selections`. Para as condições antigas, toda pizza sem observação era
 * "item simples". Pior ainda, o `id` da pizza é o do SABOR PRIMÁRIO, então
 * duas pizzas completamente diferentes (tamanhos, bordas ou conjuntos de
 * sabores distintos) casavam pelo mesmo id.
 *
 * Produto simples continua agrupando normalmente: o catálogo não devolve
 * `subitems`, então só itens de fato personalizados batem aqui.
 */
export function temPersonalizacao(item) {
  if (!item) return false;
  const steps = item.step_selections;
  return Boolean(
    item.observation ||
    item.combo_type ||
    (steps && Object.values(steps).some((v) => (Array.isArray(v) ? v.length > 0 : Boolean(v)))) ||
    (Array.isArray(item.subitems) && item.subitems.length > 0) ||
    (Array.isArray(item.etapas) && item.etapas.length > 0)
  );
}

/**
 * Linha do carrinho com a qual `produto` pode ser somado, ou `undefined`.
 * Devolve o ITEM (não o índice) pra quem chama incrementar pelo `cartItemId` —
 * casar por `id` no `map` era mais frouxo que o `find` e podia somar na linha
 * errada quando havia várias do mesmo produto.
 */
export function acharLinhaAgrupavel(cart, produto) {
  if (temPersonalizacao(produto)) return undefined;
  return (cart || []).find(
    (item) => item.id === produto.id && !temPersonalizacao(item)
  );
}
